import styled from 'styled-components';

const EmbeddedFormContainer = styled.div`
  box-sizing: border-box;
  flex-grow: 1;
  flex-basis: auto;
  flex-direction: row;
  flex-wrap: wrap;
  width: auto;
  padding-top: 12px;
  margin-left: ${props => props.theme.grid.negGutterWidth};
  margin-right: ${props => props.theme.grid.negGutterWidth};
`;

export default EmbeddedFormContainer;
